/*
 *
 * FlashMessage reducer
 *
 */
import produce from 'immer';

import { ADD_MESSAGE, REMOVE_MESSAGE } from './constants';

export const initialState = {
  messages: [],
};

const flashMessageReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case ADD_MESSAGE:
        draft.messages = [
          ...draft.messages,
          {
            id: action.id,
            text: action.text,
            variant: action.variant,
            autoClose: action.autoClose,
          },
        ];
        break;
      case REMOVE_MESSAGE:
        draft.messages = draft.messages.filter(m => m.id !== action.id);
        break;
      // no default
    }
  });

export default flashMessageReducer;
